import { Action, createReducer, on } from '@ngrx/store';

import { openPostDetails } from './post.actions';
import { feedPostsLoaded, feedUnloaded } from './feed.actions';

export interface PostState {
  selectedPostId: string | null;
}

export const initialState: PostState = {
  selectedPostId: null,
};

const _postReducer = createReducer(
  initialState,
  // The details pane defaults to the first post of a fresh result set -
  // `feed.component` broadcasts the first feed-matching entry off the list query.
  on(feedPostsLoaded, (state, { postId }) => ({
    ...state,
    selectedPostId: postId,
  })),

  on(openPostDetails, (state, { postId }) => ({
    ...state,
    selectedPostId: postId,
  })),

  on(feedUnloaded, () => initialState),
);

export function postReducer(state: PostState | undefined, action: Action) {
  return _postReducer(state, action);
}
